import { ApiService } from "./apiService"

export const ArtworksService = () => {
    return{
        getAllItem:async ()=> {
            const response =  await ApiService.get('api/items/artworks');
            return response.data;
        },
        getItemByLocation:async (id:any)=> {
            const response =  await ApiService.get(`/api/items/artworks?fields=
                title,
                century,
                description,
                image.id,
                image.width,
                image.height
                &filter[location][_eq]=${id}`);
            return response.data;
        }
    }
}